import { SearchBox, Button, OutlinedSelect } from '@octano/global-ui';
import { Col, Row } from 'reactstrap';
import { useTexts } from '../hooks/useTexts';
import { CallStatus } from '../types';
import { callStatusTranslation } from '../utils';

export function Filters() {
  const texts = useTexts().filters;
  return (
    <>
      <Row className="my-2">
        <Col xs={12} sm={3}>
          <SearchBox
            name="nameOrId"
            label={texts.nameOrId.label}
            placeholder={texts.nameOrId.placeholder}
            onChange={() => {}} //Esto evita un error hasta que este la funcionalidad
          />
        </Col>

        <Col xs={12} sm={3}>
          <OutlinedSelect
            label={texts.status.label}
            name="status"
            placeholder={texts.status.placeholder}
            options={[
              {
                label: callStatusTranslation(CallStatus.SENT),
                value: CallStatus.SENT,
              },
              {
                label: callStatusTranslation(CallStatus.ACCEPTED),
                value: CallStatus.ACCEPTED,
              },
              {
                label: callStatusTranslation(CallStatus.REJECTED),
                value: CallStatus.REJECTED,
              },
            ]}
          />
        </Col>
        <Col xs={12} sm={{ size: 3, offset: 3 }}>
          <Row>
            <Col xs={6}>
              <Button
                size="md"
                fullwidth
                type="button"
                text={texts.buttons.search}
              />
            </Col>
            <Col xs={6}>
              <Button
                size="md"
                fullwidth
                outlined
                type="button"
                text={texts.buttons.clear}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
